import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.agent.teacheraccount.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_TEACHER_ACCOUNT_ASYNC: `${uid}.saveTeacherAccountAsync`,
    SAVE_TEACHER_ACCOUNT_SUCCESS: `${uid}.saveTeacherAccountSuccess`,
    SAVE_TEACHER_ACCOUNT_FAILURE: `${uid}.saveTeacherAccountFailure`
};

export { ActionTypes };